<div class="global-share-button" [class]="shareClass" (click)="share()">
  <img src="../../../../assets/images/white-share.svg" alt="Megosztás" />
  <span>{{ shareText }}</span>
</div>
<ose-share-dialog></ose-share-dialog>
